import _ from 'lodash';
import React from 'react';
import {connect} from 'react-redux';
import {Field, reduxForm, formValueSelector} from 'redux-form';

import Label from 'components/Label';
import FormField from 'components/FormField';
import ErrorBlock from 'components/ErrorBlock';
import {TextField, AsyncSelectField} from 'components/Fields';
import {TenantInfoOption} from 'components/TenantInfo';

import {required, validEmail} from 'utils/validators';
import {clearField} from 'utils/forms';

import {addGuarantor} from 'ducks/bookings';

import {searchAgreementUsers} from 'sdk/bookings';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {fullName, email} = values;
  const {bookingId} = props;

  dispatch(
    addGuarantor(
      {bookingId, fullName, email: _.get(email, 'value')},
      props.getExtraActions()
    )
  );
};

const validate = values => ({email: validEmail(_.get(values, 'email.value'))});

class AddGuarantorForm extends React.Component<any> {
  fetchAgreementUsers = value => searchAgreementUsers({value});

  clearGuarantor = () => {
    clearField(this, {field: 'email'});
    clearField(this, {field: 'fullName'});
  };

  createNewGuarantorPrompt = label => `Create new guarantor "${label}"`;
  buildGuarantorOptions = data =>
    data.results.map(agreementUser => ({
      value: agreementUser.email,
      label: agreementUser.email,
      object: agreementUser
    }));

  render() {
    const {error, disableFullName, withoutFullName} = this.props;

    const fullNamePlaceholder = disableFullName
      ? withoutFullName ? '' : 'Add email first'
      : "Add tenant's full name";

    return (
      <form className="AddGuarantorForm">
        {error && <ErrorBlock>{error}</ErrorBlock>}
        <FormField>
          <Label>Email</Label>
          <Field
            name="email"
            validate={[required]}
            component={AsyncSelectField}
            creatable={true}
            placeholder="Search for an existing agreement user ..."
            fetchFunction={this.fetchAgreementUsers}
            buildOptions={this.buildGuarantorOptions}
            promptTextCreator={this.createNewGuarantorPrompt}
            onClear={this.clearGuarantor}
            optionRenderer={TenantInfoOption}
          />
        </FormField>
        <FormField>
          <Label>Full Name</Label>
          <Field
            name="fullName"
            placeholder={fullNamePlaceholder}
            component={TextField}
            disabled={disableFullName}
          />
        </FormField>
      </form>
    );
  }
}

const formSelector = formValueSelector('addGuarantorForm');

const mapStateToProps = state => {
  const email = formSelector(state, 'email');

  const initialValues = {fullName: _.get(email, 'object.fullName')};

  const disableFullName = _.isNil(email) || email.object;

  const withoutFullName = initialValues.fullName !== undefined;

  return {initialValues, disableFullName, withoutFullName};
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'addGuarantorForm',
    onSubmit: formSubmit,
    validate,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })(AddGuarantorForm)
);
